import { Box, Flex, Image, PseudoBox, Text } from '@chakra-ui/core';
import { useObserver } from 'mobx-react';
import React from 'react';

import { useStores } from '../hooks/useStores';
import { IQueueItemModel } from '../stores/models/QueueItemModel';

interface QueueItemProps {
    item: IQueueItemModel;
    current?: boolean;
    author?: boolean;
}

function useStoreData() {
    const { store } = useStores();
    return useObserver(() => ({
        currentTrackColors: store.config.currentTrackColors,
    }));
}

const QueueItem: React.FC<QueueItemProps> = ({ item, current = false, author = true }) => {
    const { currentTrackColors } = useStoreData();
    const { track } = item;
    return (
        <PseudoBox
            _hover={{ bg: 'rgba(0,0,0,.1)' }}
            as="div"
            d="flex"
            p=".5rem 1rem"
            alignItems="center"
            transition="all .3s ease"
            w="100%"
        >
            <Image
                alt={track.name}
                rounded="full"
                mr="1rem"
                transition="all .3s ease"
                size="50px"
                src={track.imageUrl}
                ignoreFallback
            />
            <Flex direction="column" flex={1}>
                <Text
                    flex={1}
                    color={current ? currentTrackColors[1] : 'white'}
                    fontWeight={current ? 'bold' : 'normal'}
                    opacity={current ? 1 : 0.8}
                    maxW={['150px', '250px', '200px', '290px']}
                    isTruncated
                >
                    {track.name}
                </Text>
                <Text maxW={['130px', '230px', '180px', '250px']} isTruncated fontSize="14px" opacity={0.8} flex={1}>
                    {track.artists}
                </Text>
            </Flex>
            {author && (
                <Flex alignSelf="flex-end" direction="column-reverse" justifyContent="space-between" h="100%">
                    {item.user && (
                        <Text alignSelf="flex-end" fontSize="12px" opacity={0.5}>
                            by {item.user.displayName}
                        </Text>
                    )}
                </Flex>
            )}
        </PseudoBox>
    );
};

export default QueueItem;
